import $ from 'jquery';

(function(){
    "use strict";

    // Global search
    var $globalSearch = $(".global-search");
    var $searchToggle = $(".header-search-toggle")

    // Expand search bar
    $searchToggle.click(function () {
        $globalSearch.fadeIn(150, function () {
            document.getElementById("header-search").focus();
        });
    });

    // Collapse search bar - focusout/click
    $globalSearch.on("focusout", function(e) {
        setTimeout(function() {
            if ($globalSearch.find(":focus").length === 0) {
                if (!$(".icon-menu-toggle").is(":visible")) {
                    $globalSearch.fadeOut(150);
                }
            }
        }, 0);
    });

    // Collapse search bar - Esc key
    $globalSearch.on("keydown", function(e) {
        if (e.keyCode === 27) {
            if (!$(".icon-menu-toggle").is(":visible")) {
                $globalSearch.fadeOut(150);
                $searchToggle.focus();
            }
        }
    });

    // Mobile Nav
    var $navToggle = $(".icon-menu-toggle");

    // Toggle mobile menu
    $navToggle.on("click", function() {
        if ($navToggle.hasClass("active")) {
            $navToggle.removeClass("active");
            $(".primary-nav-container").slideUp(300);
        }
        else {
            $navToggle.addClass("active");
            $(".primary-nav-container").slideDown(300);
            setTimeout(function() {
                $(".header-nav > li:first-child > a").focus();
            }, 301);
        }
    });

    // Desktop Nav
    var $headerNav = $(".header-nav");
    var $navLinks = $(".header-nav > li > a");

    // Expand megamenu on top level item focus
    $navLinks.on("focusin", function(e) {
        closeMegaMenu();
        if (!$navToggle.is(":visible")) {
            var $navItem = $(this).parent();
            $navItem.addClass("open");
        }
    });

    // Handle nav keypress
    $headerNav.on("keydown", function(e) {

        // Esc
        if (e.keyCode === 27) {

            // Close mobile nav
            if ($navToggle.is(":visible")) {
                $navToggle.click();
                $navToggle.focus();

            // Close desktop megamenu
            } else {
                var $activeItem = $(".header-nav > li.open");
                if ($activeItem.length > 0) {
                    $(".header-nav > li.open > a").focus();
                    $activeItem.removeClass("open");
                }
            }
        }

        // TAB
        if (e.keyCode === 9) {
            setTimeout(function() {
                if ($headerNav.find(":focus").length === 0) {

                    // Close mobile nav on tab out
                    if ($navToggle.is(":visible")) {
                        $navToggle.click();
                        $navToggle.focus();
                    }
                }
            }, 0);
        }
    });

    // Close desktop megamenu
    $headerNav.on("focusout", function(e) {
        setTimeout(function() {
            if ($headerNav.find(":focus").length === 0) {

                if (!$navToggle.is(":visible")) {
                    closeMegaMenu();
                }
            }
        }, 0);
    });


    // Close megamenu
    function closeMegaMenu() {
        var $activeItem = $(".header-nav > li.open");
        if ($activeItem.length > 0) {
            $activeItem.removeClass("open");
        }
    }

    $(document).ready(function () {
        function initSubmenuFix() {
            var nav = $('.header-nav');
            var allListItems = nav.find('> li');

            allListItems.each(function (idx, listItem) {
                $(listItem).hover(
                    function () {
                        console.log("enter");
                        var submenu = $(listItem).find('> ul');
                        var leftBound = submenu.offset().left
                        var rightBound = leftBound + submenu.width();
                        var windowWidth = $(window).width();
                        if (rightBound > windowWidth) {
                            var diff = rightBound - windowWidth;
                            var newLeft = leftBound - diff;
                            submenu.offset({
                                left: newLeft
                            })
                        }
                    },
                    function () {
                        console.log("leave")
                    }
                );
            })
            /*
            $( "li" ).hover(
              function() {
                $( this ).append( $( "<span> ***</span>" ) );
              }, function() {
                $( this ).find( "span" ).last().remove();
              }
            );*/
            console.log("NAV", allListItems);

        }

        initSubmenuFix();
    });

}());
